/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Clear_Event_TextInputs */



/**
* | output |
* | --- |
* | "Clear the text of the selected Events" |
*
* @param {Shortcut_Keys_Desc_Clear_Event_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_clear_event_text = /** @type {((inputs?: Shortcut_Keys_Desc_Clear_Event_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Clear_Event_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Effacer le texte des evenements selectionnes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Den Text der ausgewählten Ereignisse löschen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cancella il testo degli eventi selezionati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Очистить текст выбранных событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Borrar el texto de los eventos seleccionados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("清除所选事件的文本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントのテキストをクリアします")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित इवेंट्स का टेक्स्ट साफ़ करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Limpar o texto dos eventos selecionados")
	return /** @type {LocalizedString} */ ("Clear the text of the selected Events")
});